

/// <reference path="LocalizedEntity.ts" />

// Generated class ReportLocalized_ManagedObject

class ReportLocalized_ManagedObject extends LocalizedEntity
{

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: section
    set section(value:string) {
        this.setValueForKey(value, 'section');
    }
    get section():string {
        return this.valueForKey('section');
    }
    set sectionPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'section');
    }
    get sectionPrimitiveValue():string {
        return this.primitiveValueForKey('section');
    }
    // Relationship: report
    set report(value:Report) {
        this.setValueForKey(value, 'report');
    }
    get report():Report {
        return this.valueForKey('report') as Report;
    }
}
